<template>
  <div class="heading-four">
    <h3 class="heading"><slot></slot></h3>
  </div>
</template>

<script>
export default {
  name: "HeadingFour",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.heading-four {
  > .heading {
    font-size: 14px;
    font-weight: bold;
    @include mq-up(md) {
      font-size: 16px;
    }
  }
}
</style>
